<template>
  <section class="edit-user-box">

    <form id="formUser" class="form-user">

      <div class="form-row">
        <div class="col-md-6 mb-3">
          <label for="name">Nome</label>
          <input type="text" class="form-control" id="name" v-model="usuario.name" required>
        </div>
        <div class="col-md-4 mb-3">
          <label for="email">E-mail</label>
          <div class="input-group">
                          <span class="input-group-addon email-icon">
                            <i aria-hidden="true" class="fa fa-fw fa-at"></i>
                          </span>
            <input id="email" type="text" class="form-control email-input"
                   v-model="usuario.email"
                   required>
          </div>
        </div>
      </div>

      <div class="form-row-2">
        <div class="col-md-4 mb-3">
          <label for="name">Usuário</label>
          <input type="text" placeholder="CPF" class="form-control" maxlength="11" id="name"
                 v-model="usuario.username" required>
        </div>
      </div>

      <div class="form-row-3">
        <div class="col-md-3 mb-3">
          <div class="form-group">
            <label>Perfil</label>
            <select multiple="multiple" size="5" v-model="usuario.roles" class="form-control" required>
              <option v-for="role in listaRoles" :key="role.id" :value="role">{{ role.name }}</option>
            </select>
          </div>
        </div>

        <div class="col-md-3 mb-3">
          <div class="form-group">
            <label>Skin</label>
            <select multiple="multiple" size="5" v-model="usuario.skin" class="form-control" required>
              <option v-for="skin in listaSkin" :key="skin.id" :value="skin">{{ skin.name }}</option>
            </select>
          </div>
        </div>

        <div class="col-md-2 mb-3">
          <div class="form-check checkbox-agente">
            <input class="form-check-input" type="checkbox" id="agent"
                   v-model="usuario.agent">
            <label class="form-check-label" for="agent">
              Agente de Registro
            </label>
          </div>
        </div>
      </div>

      <div class="form-row-4">
        <div class="col-md-10 mb-10">
          <div class="form-group">
            <label>Exceções Biométricas:</label>
          </div>
        </div>

        <div class="col-md-3 mb-3" style="width: 17% !important;">
          <input class="form-check-input" type="checkbox" id="LeftHand"
                 v-on:click="checkControll('LeftHand')" v-model="leftHand">
          <label class="form-check-label" for="LeftHand">
            Mão Esquerda
          </label> <br>
          <input class="form-check-input" type="checkbox" id="LeftThumb"
                 v-on:click="checkControll('LeftThumb')" v-model="leftThumb" :disabled="leftHand">
          <label class="form-check-label" for="LeftThumb">
            Polegar Esquerdo
          </label> <br>
          <input class="form-check-input" type="checkbox" id="LeftIndexFinger"
                 v-on:click="checkControll('LeftIndexFinger')" v-model="leftIndexFinger"
                 :disabled="leftHand">
          <label class="form-check-label" for="LeftIndexFinger">
            Indicador Esquerdo
          </label> <br>
          <input class="form-check-input" type="checkbox" id="LeftMiddleFinger"
                 v-on:click="checkControll('LeftMiddleFinger')" v-model="leftMiddleFinger"
                 :disabled="leftHand">
          <label class="form-check-label" for="LeftMiddleFinger">
            Médio Esquerdo
          </label> <br>
          <input class="form-check-input" type="checkbox" id="LeftRingFinger"
                 v-on:click="checkControll('LeftRingFinger')" v-model="leftRingFinger"
                 :disabled="leftHand">
          <label class="form-check-label" for="LeftRingFinger">
            Anelar Esquerdo
          </label> <br>
          <input class="form-check-input" type="checkbox" id="LeftLittleFinger"
                 v-on:click="checkControll('LeftLittleFinger')" v-model="leftLittleFinger"
                 :disabled="leftHand">
          <label class="form-check-label" for="LeftLittleFinger">
            Mínimo Esquerdo
          </label>
        </div>

        <div class="col-md-3 mb-3">
          <select style="width: 80%;" id="sel_LeftHand" v-model="leftHandReason"
                  :disabled="!this.leftHand">
            <option v-for="reason in listReasons" :key="reason.id" :value="reason.id">{{ reason.reason }}
            </option>
          </select> <br>
          <select style="width: 80%; margin-top: 5px;" id="sel_LeftThumb" v-model="leftThumbReason"
                  :disabled="!this.leftThumb">
            <option v-for="reason in listReasons" :key="reason.id" :value="reason.id">{{ reason.reason }}
            </option>
          </select> <br>
          <select style="width: 80%; margin-top: 5px;" id="sel_LeftIndexFinger"
                  v-model="leftIndexFingerReason" :disabled="!this.leftIndexFinger">
            <option v-for="reason in listReasons" :key="reason.id" :value="reason.id">{{ reason.reason }}
            </option>
          </select> <br>
          <select style="width: 80%; margin-top: 5px;" id="sel_LeftMiddleFinger"
                  v-model="leftMiddleFingerReason" :disabled="!this.leftMiddleFinger">
            <option v-for="reason in listReasons" :key="reason.id" :value="reason.id">{{ reason.reason }}
            </option>
          </select> <br>
          <select style="width: 80%; margin-top: 5px;" id="sel_LeftRingFinger"
                  v-model="leftRingFingerReason" :disabled="!this.leftRingFinger">
            <option v-for="reason in listReasons" :key="reason.id" :value="reason.id">{{ reason.reason }}
            </option>
          </select> <br>
          <select style="width: 80%; margin-top: 5px;" id="sel_LeftLittleFinger"
                  v-model="leftLittleFingerReason" :disabled="!this.leftLittleFinger">
            <option v-for="reason in listReasons" :key="reason.id" :value="reason.id">{{ reason.reason }}
            </option>
          </select> <br>
        </div>

        <div class="col-md-3 mb-3" style="width: 17% !important;">
          <input class="form-check-input" type="checkbox" id="RightHand"
                 v-on:click="checkControll('RightHand')" v-model="rightHand">
          <label class="form-check-label" for="RightHand">
            Mão Direita
          </label> <br>
          <input class="form-check-input" type="checkbox" id="RightThumb"
                 v-on:click="checkControll('RightThumb')" v-model="rightThumb" :disabled="rightHand">
          <label class="form-check-label" for="RightThumb">
            Polegar Direito
          </label> <br>
          <input class="form-check-input" type="checkbox" id="RightIndexFinger"
                 v-on:click="checkControll('RightIndexFinger')" v-model="rightIndexFinger"
                 :disabled="rightHand">
          <label class="form-check-label" for="RightIndexFinger">
            Indicador Direito
          </label> <br>
          <input class="form-check-input" type="checkbox" id="RightMiddleFinger"
                 v-on:click="checkControll('RightMiddleFinger')" v-model="rightMiddleFinger"
                 :disabled="rightHand">
          <label class="form-check-label" for="RightMiddleFinger">
            Médio Direito
          </label> <br>
          <input class="form-check-input" type="checkbox" id="RightRingFinger"
                 v-on:click="checkControll('RightRingFinger')" v-model="rightRingFinger"
                 :disabled="rightHand">
          <label class="form-check-label" for="RightRingFinger">
            Anelar Direito
          </label> <br>
          <input class="form-check-input" type="checkbox" id="RightLittleFinger"
                 v-on:click="checkControll('RightLittleFinger')" v-model="rightLittleFinger"
                 :disabled="rightHand">
          <label class="form-check-label" for="RightLittleFinger">
            Mínimo Direito
          </label>
        </div>

        <div class="col-md-3 mb-3">
          <select style="width: 80%;" id="sel_RightHand" v-model="rightHandReason"
                  :disabled="!this.rightHand">
            <option v-for="reason in listReasons" :key="reason.id" :value="reason.id">{{ reason.reason }}
            </option>
          </select> <br>
          <select style="width: 80%; margin-top: 5px;" id="sel_RightThumb" v-model="rightThumbReason"
                  :disabled="!this.rightThumb">
            <option v-for="reason in listReasons" :key="reason.id" :value="reason.id">{{ reason.reason }}
            </option>
          </select> <br>
          <select style="width: 80%; margin-top: 5px;" id="sel_RightIndexFinger"
                  v-model="rightIndexFingerReason" :disabled="!this.rightIndexFinger">
            <option v-for="reason in listReasons" :key="reason.id" :value="reason.id">{{ reason.reason }}
            </option>
          </select> <br>
          <select style="width: 80%; margin-top: 5px;" id="sel_RightMiddleFinger"
                  v-model="rightMiddleFingerReason" :disabled="!this.rightMiddleFinger">
            <option v-for="reason in listReasons" :key="reason.id" :value="reason.id">{{ reason.reason }}
            </option>
          </select> <br>
          <select style="width: 80%; margin-top: 5px;" id="sel_RightRingFinger"
                  v-model="rightRingFingerReason" :disabled="!this.rightRingFinger">
            <option v-for="reason in listReasons" :key="reason.id" :value="reason.id">{{ reason.reason }}
            </option>
          </select> <br>
          <select style="width: 80%; margin-top: 5px;" id="sel_RightLittleFinger"
                  v-model="rightLittleFingerReason" :disabled="!this.rightLittleFinger">
            <option v-for="reason in listReasons" :key="reason.id" :value="reason.id">{{ reason.reason }}
            </option>
          </select> <br>
        </div>

        <div style="clear:both;"></div>

        <br/>
      </div>

      <div class="form-group">
        <div v-if="check('SAVE')" class="col-md-1 mb-3">
          <button type="submit" v-on:click="saveUser($event)" class="btn btn-primary">Salvar</button>
        </div>
        <div class="col-md-1 mb-3">
          <button type="button" v-on:click="cancel()" class="btn btn-secondary">Cancelar</button>
        </div>
        <div style="clear:both;"></div>
      </div>
    </form>

  </section>
</template>

<script>
import $ from 'jquery'
import interceptor from '../../interceptor'
import roles from '../../roles'
import Exceptions from '../../model/Exceptions'
import Usuario from '../../model/Usuario'

export default {
  name: 'NewUser',
  data: function () {
    return {
      usuario: new Usuario(),
      listaReasons: [],
      listaRoles: [],
      listaSkin: [],
      leftHand: false,
      leftHandReason: '',
      leftThumb: false,
      leftThumbReason: '',
      leftIndexFinger: false,
      leftIndexFingerReason: '',
      leftMiddleFinger: false,
      leftMiddleFingerReason: '',
      leftRingFinger: false,
      leftRingFingerReason: '',
      leftLittleFinger: false,
      leftLittleFingerReason: '',
      rightHand: false,
      rightHandReason: '',
      rightThumb: false,
      rightThumbReason: '',
      rightIndexFinger: false,
      rightIndexFingerReason: '',
      rightMiddleFinger: false,
      rightMiddleFingerReason: '',
      rightRingFinger: false,
      rightRingFingerReason: '',
      rightLittleFinger: false,
      rightLittleFingerReason: ''
    }
  },
  mounted() {
    this.listReasons()
    this.listRoles()
    this.listSkins()
  },
  methods: {
    checkControll: function (finger) {
      let check = $('#' + finger).is(':checked')
      if (!check) {
        setTimeout(() => $('#sel_' + finger).val(''), 100)
      }
    },
    listReasons: function () {
      interceptor.request('get', 'api/v1/reasons', {})
        .then(response => {
          if (response.data) {
            this.listReasons = response.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    listRoles: function () {
      interceptor.request('get', 'api/v1/roles?role=' + window.localStorage.getItem('role'), {})
        .then(response => {
          if (response.data) {
            this.listaRoles = response.data
          }
        })
    },
    listSkins: function () {
      this.listaSkin = []
      interceptor.request('get', 'api/v1/skin/active', {})
        .then(response => {
          this.listaSkin = response.data
        })
    },
    check: function (action) {
      return roles.checkrole(window.localStorage.getItem('role'), this.key, action)
    },
    cancel: function () {
      document.getElementById('newUser').click()
      $('#newUser').show()
      this.clearAlert()
    },
    saveUser: function (event) {
      event.preventDefault()
      this.clearAlert()
      if (this.usuario.name !== undefined && this.usuario.email !== undefined && this.usuario.username !== undefined && this.usuario.roles !== undefined && this.usuario.skin !== undefined) {
        if (this.check('SAVE')) {
          console.log('its here')
          this.usuario.exceptions = []
          this.usuario.operator = window.localStorage.getItem('usercod')
          this.makeExceptionObject()
          interceptor.request('post', 'api/v1/users', this.usuario)
            .then(() => {
              $('#divUser').attr('class', 'collapsin')
              $('#divUser').attr('class', 'collapse')
              $('#divAlert').attr('class', 'alert alert-success').append('<p style="font-weight: bold;">Usuário cadastrado com Sucesso.</p>').show()
              this.listUsers()
            })
            .catch(error => {
              var msg = error.response.status
              if (msg === 409) {
                $('#divAlert').attr('class', 'alert alert-danger')
                  .append('<p style="font-weight: bold;">Já existe usuário cadastrado com o username ou e-mail informado.</p>')
                  .show()
              } else if (msg === 500) {
                $('#divAlert').attr('class', 'alert alert-danger')
                  .append('<p style="font-weight: bold;">Erro ao tentar salvar o usuario. </p>')
                  .show()
              } else {
                $('#divAlert').attr('class', 'alert alert-danger')
                  .append('<p style="font-weight: bold;">Erro ao tentar salvar o usuario. Serviço indisponível.</p>')
                  .show()
              }
            })
        } else {
          $('#divAlert').attr('class', 'alert alert-danger')
            .append('<p style="font-weight: bold;">Você não tem permissão para executar esta ação. </p>')
            .show()
        }
      } else {
        if (this.usuario.name === undefined) {
          $('#divAlert').attr('class', 'alert alert-warning')
            .append('<p style="font-weight: bold;">O campo Nome é de preenchimento obrigatório.</p>')
            .show()
        } else if (this.usuario.email === undefined) {
          $('#divAlert').attr('class', 'alert alert-warning')
            .append('<p style="font-weight: bold;">O campo E-mail é de preenchimento obrigatório.</p>')
            .show()
        } else if (this.usuario.username === undefined) {
          $('#divAlert').attr('class', 'alert alert-warning')
            .append('<p style="font-weight: bold;">O campo Usuário é de preenchimento obrigatório.</p>')
            .show()
        } else if (this.usuario.roles === undefined) {
          $('#divAlert').attr('class', 'alert alert-warning')
            .append('<p style="font-weight: bold;">O campo Perfil deve ser selecionado.</p>')
            .show()
        } else if (this.usuario.skin === undefined) {
          $('#divAlert').attr('class', 'alert alert-warning')
            .append('<p style="font-weight: bold;">O campo Perfil deve ser selecionado.</p>')
            .show()
        }
      }
      $('#newUser').show()
    },
    makeExceptionObject: function () {
      if (this.rightHand) {
        this.rightThumb = true
        this.rightThumbReason = this.rightHandReason
        this.rightIndexFinger = true
        this.rightIndexFingerReason = this.rightHandReason
        this.rightMiddleFinger = true
        this.rightMiddleFingerReason = this.rightHandReason
        this.rightRingFinger = true
        this.rightRingFingerReason = this.rightHandReason
        this.rightLittleFinger = true
        this.rightLittleFingerReason = this.rightHandReason
      }
      if (this.rightThumb) {
        let exception = new Exceptions()
        exception.setType('finger')
        exception.setSubType('RightThumb')
        exception.setException(this.rightThumbReason)
        this.usuario.exceptions.push(exception)
      }
      if (this.rightIndexFinger) {
        let exception = new Exceptions()
        exception.setType('finger')
        exception.setSubType('RightIndexFinger')
        exception.setException(this.rightIndexFingerReason)
        this.usuario.exceptions.push(exception)
      }
      if (this.rightMiddleFinger) {
        let exception = new Exceptions()
        exception.setType('finger')
        exception.setSubType('RightMiddleFinger')
        exception.setException(this.rightMiddleFingerReason)
        this.usuario.exceptions.push(exception)
      }
      if (this.rightRingFinger) {
        let exception = new Exceptions()
        exception.setType('finger')
        exception.setSubType('RightRingFinger')
        exception.setException(this.rightRingFingerReason)
        this.usuario.exceptions.push(exception)
      }
      if (this.rightLittleFinger) {
        let exception = new Exceptions()
        exception.setType('finger')
        exception.setSubType('RightLittleFinger')
        exception.setException(this.rightLittleFingerReason)
        this.usuario.exceptions.push(exception)
      }
      if (this.leftHand) {
        this.leftThumb = true
        this.leftThumbReason = this.leftHandReason
        this.leftIndexFinger = true
        this.leftIndexFingerReason = this.leftHandReason
        this.leftMiddleFinger = true
        this.leftMiddleFingerReason = this.leftHandReason
        this.leftRingFinger = true
        this.leftRingFingerReason = this.leftHandReason
        this.leftLittleFinger = true
        this.leftLittleFingerReason = this.leftHandReason
      }
      if (this.leftThumb) {
        let exception = new Exceptions()
        exception.setType('finger')
        exception.setSubType('LeftThumb')
        exception.setException(this.leftThumbReason)
        this.usuario.exceptions.push(exception)
      }
      if (this.leftIndexFinger) {
        let exception = new Exceptions()
        exception.setType('finger')
        exception.setSubType('LeftIndexFinger')
        exception.setException(this.leftIndexFingerReason)
        this.usuario.exceptions.push(exception)
      }
      if (this.leftMiddleFinger) {
        let exception = new Exceptions()
        exception.setType('finger')
        exception.setSubType('LeftMiddleFinger')
        exception.setException(this.leftMiddleFingerReason)
        this.usuario.exceptions.push(exception)
      }
      if (this.leftRingFinger) {
        let exception = new Exceptions()
        exception.setType('finger')
        exception.setSubType('LeftRingFinger')
        exception.setException(this.leftRingFingerReason)
        this.usuario.exceptions.push(exception)
      }
      if (this.leftLittleFinger) {
        let exception = new Exceptions()
        exception.setType('finger')
        exception.setSubType('LeftLittleFinger')
        exception.setException(this.leftLittleFingerReason)
        this.usuario.exceptions.push(exception)
      }
    },
    clearAlert: function () {
      $('.alert').hide()
      $('#divAlert').empty()
    }
  }
}
</script>

<style scoped>
.edit-user-box {
}

.form-user {
  padding: 10px;
}

.form-row {
  margin-top: 5px;
}

.email-icon {
  height: auto;
  background: #d6d1d1;
  padding: 4px 25px 0 8px;
}

.email-input {
  height: auto;
}

.checkbox-agente {
  display: flex;
  gap: 1rem;
}

.checkbox-agente > input {
  padding: 7px;
}

.checkbox-agente > label {
  margin: auto 0;
}
select {
  border: lightslategrey solid 1px;
  border-radius: 2%;
}
</style>



// WEBPACK FOOTER //
// NewUser.vue?18c87a42